import dynamic from "next/dynamic";

export const DynamicContent054 = dynamic(() => import("./Content054"), {
  suspense: true,
});
